// extracted by mini-css-extract-plugin
export default {"pageBody":"PageContainer_pageBody__p+XJr"};